import { injectGlobal } from 'react-emotion'

import KeyCode from './keyCodes'

const focusByClickClassName = 'focus-by-click'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function clickHandler(event: MouseEvent) {
  document.body.classList.add(focusByClickClassName)

  window.removeEventListener('click', clickHandler)
  window.addEventListener('keydown', keydownHandler)
}

function keydownHandler(event: KeyboardEvent) {
  if (
    event.keyCode !== KeyCode.Tab &&
    event.keyCode !== KeyCode.Space &&
    event.keyCode !== KeyCode.Left &&
    event.keyCode !== KeyCode.Right &&
    event.keyCode !== KeyCode.Up &&
    event.keyCode !== KeyCode.Down
  ) {
    return
  }

  document.body.classList.remove(focusByClickClassName)

  window.removeEventListener('keydown', keydownHandler)
  window.addEventListener('click', clickHandler)
}

export default function init() {
  injectGlobal`
    .${focusByClickClassName} *:focus {
      outline: 0;
    }
  `

  window.addEventListener('click', clickHandler)
}
